module.exports = __webpack_public_path__ + "img/ic-brand-asana.e5d4c72a.svg";